import { __extends } from "tslib";
import React from 'react';
import s from './Header.scss';
import _get from 'lodash/get';
import RoundedHeader from './RoundedHeader/RoundedHeader';
import MobileCollapsedHeader from './MobileCollapsedHeader/MobileCollapsedHeader';
import RectHeader from './RectHeader/RectHeader';
import withTranslation from '../../../providers/translation/withTranslation';
import withTheme from '../../../providers/theme/withTheme';
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderMobileCollapsed = function () {
            var _a = _this.props, shouldApplyCollapseAnimation = _a.shouldApplyCollapseAnimation, onlineTitle = _a.onlineTitle;
            return (React.createElement(MobileCollapsedHeader, { shouldApplyCollapseAnimation: shouldApplyCollapseAnimation, onlineTitle: onlineTitle }));
        };
        _this.renderDesktopRoundedCollapsed = function () {
            var _a = _this.props, shouldApplyCollapseAnimation = _a.shouldApplyCollapseAnimation, onlineTitle = _a.onlineTitle;
            return (React.createElement(RoundedHeader, { shouldApplyCollapseAnimation: shouldApplyCollapseAnimation, onlineTitle: onlineTitle }));
        };
        _this.renderRectangleHeader = function () {
            var _a = _this.props, clickable = _a.clickable, isExpanded = _a.isExpanded, onClickBack = _a.onClickBack, onCancel = _a.onCancel, shouldApplyExpandAnimation = _a.shouldApplyExpandAnimation, shouldApplyCollapseAnimation = _a.shouldApplyCollapseAnimation, onlineTitle = _a.onlineTitle, onlineMessage = _a.onlineMessage, avatar = _a.avatar, isHeaderFolded = _a.isHeaderFolded, shouldApplyFoldAnimation = _a.shouldApplyFoldAnimation, shouldApplyUnfoldAnimation = _a.shouldApplyUnfoldAnimation, toggleHeaderFolded = _a.toggleHeaderFolded, isMobile = _a.isMobile, availabilityStatus = _a.availabilityStatus, hideCollapseButton = _a.hideCollapseButton, onProfileClick = _a.onProfileClick, menu = _a.menu, typicallyReplies = _a.typicallyReplies;
            return (React.createElement(RectHeader, { hideCollapseButton: hideCollapseButton, clickable: clickable, onClickBack: onClickBack, onCancel: onCancel, isExpanded: isExpanded, onlineTitle: onlineTitle, onlineMessage: onlineMessage, avatar: avatar, isHeaderFolded: isHeaderFolded, shouldApplyFoldAnimation: shouldApplyFoldAnimation, shouldApplyUnfoldAnimation: shouldApplyUnfoldAnimation, toggleHeaderFolded: toggleHeaderFolded, isMobile: isMobile, shouldApplyExpandAnimation: shouldApplyExpandAnimation, shouldApplyCollapseAnimation: shouldApplyCollapseAnimation, availabilityStatus: availabilityStatus, onProfileClick: onProfileClick, menu: menu, typicallyReplies: typicallyReplies }));
        };
        _this.getRenderedHeader = function () {
            var _a = _this.props, isExpanded = _a.isExpanded, theme = _a.theme, isMobile = _a.isMobile;
            var collapsedAsRounded = _get(theme, 'header.collapsedAsRounded', false);
            var shouldBeMobileCollapsed = !isExpanded && isMobile;
            var shouldBeDesktopRounded = !isExpanded && collapsedAsRounded;
            if (shouldBeMobileCollapsed) {
                return _this.renderMobileCollapsed();
            }
            if (shouldBeDesktopRounded) {
                return _this.renderDesktopRoundedCollapsed();
            }
            return _this.renderRectangleHeader();
        };
        return _this;
    }
    Header.prototype.render = function () {
        return (React.createElement("div", { "data-hook": "header-wrapper", "aria-expanded": this.props.isExpanded, className: s.root }, this.getRenderedHeader()));
    };
    Header.defaultProps = {
        clickable: true,
    };
    return Header;
}(React.Component));
export default withTranslation(withTheme(Header));
//# sourceMappingURL=Header.js.map